var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.953 7.742a.83.83 0 00-1.175 0l-3.233 3.233-3.233-3.233a.83.83 0 10-1.175 1.175l3.825 3.825a.83.83 0 001.175 0l3.825-3.825a.838.838 0 00-.009-1.175z",
    fill: "#000"
  })));
}
export default SvgChevronDown;